import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';

const Subheading = styled(Typography).attrs(() => ({ as: 'h3' }))`
  color: ${({ theme }) => theme.palette.grey[900]};
  font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  font-weight: 500;
`;

Subheading.propTypes = {
  children: PropTypes.node,
};

Subheading.defaultProps = {
  children: undefined,
};

/** @component */
export default Subheading;
